import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cbbc4fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-system" }, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "btn-box"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["message-system", [ _ctx.isH5 ? 'message-system-h5' : '']])
  }, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageList, (item, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, [
          (item.type === _ctx.types.MSG_GRP_TIP || item.type === _ctx.types.MSG_GRP_SYS_NOTICE)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_2,
                _createElementVNode("span", null, _toDisplayString(_ctx.translateGroupSystemNotice(item)), 1),
                (item?.payload?.operationType === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      (!item.isHandle)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-default",
                            onClick: ($event: any) => (_ctx.handleApplication('Agree', item))
                          }, _toDisplayString(_ctx.$t('TUIContact.接受')), 9, _hoisted_4))
                        : _createCommentVNode("", true),
                      (!item.isHandle)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "btn btn-cancel",
                            onClick: ($event: any) => (_ctx.handleApplication('Reject', item))
                          }, _toDisplayString(_ctx.$t('TUIContact.拒绝')), 9, _hoisted_5))
                        : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('TUIContact.已处理')), 1))
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ], 2))
}